module.exports = __webpack_public_path__ + "static/media/mailnews_3.1ef8b957.ico";